module.exports = __webpack_public_path__ + "static/media/ic-mentee-info-on.cf08b4c8.webp";